import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IBitfApiResponse, IBitfApiRequest } from '@web/interfaces';
import { BitfFormItemConfig } from '@web/core/models';

@Injectable({
  providedIn: 'root',
})
export class TagsService extends BitfApiService {
  constructor(public injector: Injector) {
    super('splist/tags', injector);
    // super('splist/tags', injector, environment.mockApiUrl, 'mockDbParser');
  }

  getFormItemConfig(): Observable<IBitfApiResponse<BitfFormItemConfig>> {
    return super.request({
      method: 'GET',
      path: '/form-items-config',
      modelMapper: 'form-items-config',
    } as IBitfApiRequest);
  }
}
